// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__qQ8S1","sticky":"Navbar_sticky__nfTr0","buttonContainer":"Navbar_buttonContainer__tRTxx","historyButton":"Navbar_historyButton__Z3K73"};